import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { PlanningService } from '../../../_services/planning.service';
declare var jQuery: any;
import '../../../../assets/semantic/semantic.min.js';

@Component({
  selector: 'app-delete-planning',
  templateUrl: './delete-planning.component.html',
  styleUrls: ['./delete-planning.component.css']
})
export class DeletePlanningComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();

  private to_delete;

  constructor(private service: PlanningService) { }

  ngOnInit() {
  }

  openModal(planning_id) {
    this.to_delete = planning_id;
    jQuery('#delete-planning-modal').modal({ closable: false }).modal('show');
  }

  deletePlanning() {
    if (!this.to_delete) { // Return false if the ID of the planning is not stored
      jQuery('#delete-planning-modal').modal('hide');
      return false;
    }
    let planning_id = this.to_delete // Store it in a var
    this.to_delete = undefined; // Invalidate the planning to delete (avoid spamming during the deletion process)
    jQuery('#delete-planning-modal').modal({ closable: false }); // Set the modal unclosable during the deletion process
    this.service.deletePlanning(planning_id) // Delete the planning
      .subscribe(response => {
        jQuery('#delete-planning-modal').modal('hide');
        this.refresh.emit(true); // Close the modal
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/planning/delete-planning/delete-planning.component.ts